// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"b6c735e1","221":"995f76a2"}[chunkId] + ".chunk.css";
};